export {default} from './Pill';
